import { render, staticRenderFns } from "./Control_instance.vue?vue&type=template&id=b22de5ea&lang=pug&"
import script from "./Control_instance.vue?vue&type=script&lang=js&"
export * from "./Control_instance.vue?vue&type=script&lang=js&"
import style0 from "./Control_instance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports